import './Error.css';

function Error({ message = 'Oops! Something went wrong.' }) {
    return <div className="error-wrapper">{message}</div>;
}

export default Error;
